/**
 * HTML 转义工具
 * 防止 XSS 攻击
 */

const ESCAPE_MAP: Record<string, string> = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
};

/**
 * 转义 HTML 特殊字符
 * @param text - 需要转义的文本
 * @returns 转义后的文本
 */
export const escapeHtml = (text: string): string => {
  if (!text) return '';
  return text.replace(/[&<>"']/g, (char) => ESCAPE_MAP[char] || char);
};

/**
 * 验证 URL 是否安全
 * @param url - 需要验证的 URL
 * @returns 是否安全
 */
export const isSafeUrl = (url: string): boolean => {
  try {
    const urlObj = new URL(url, window.location.href);
    return ['http:', 'https:', 'data:'].includes(urlObj.protocol);
  } catch {
    return false;
  }
};
